import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "performance"
const PerformanceIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            d="M19.5 8.25C20.328 8.25 21 8.922 21 9.75V20.25H21.75V21.75H2.25V20.25H3V15.75C3 14.922 3.672 14.25 4.5 14.25H6.75C7.578 14.25 8.25 14.922 8.25 15.75V20.25H9.375V12.75C9.375 11.922 10.047 11.25 10.875 11.25H13.125C13.953 11.25 14.625 11.922 14.625 12.75V20.25H15.75V9.75C15.75 8.922 16.422 8.25 17.25 8.25zM4.5 20.25H6.75V15.75H4.5zM10.875 20.25H13.125V12.75H10.875zM17.25 20.25H19.5V9.75H17.25z"
            clipRule="evenodd"
          />
          <path d="M17.045 6.344 15.883 4.619 5.683 11.862 4.817 10.638 15.043 3.375 13.8 1.533 19.03 1.504z" />
        </svg>
      }
    </span>
  )
}
export default PerformanceIcon
